export class DocumentPage {
  public id:number;
  public fileId:number;
  public content: string[];
  public tagName:string;
  public user:string;
  public sid:string;
  public file: string;
  public pageList: number[];
}
